export default __webpack_public_path__ + "static/media/000_intro_part2.av1.5d9a45a9.mp4";